export default __webpack_public_path__ + "static/media/gwn07.2f1b0c91.webp";